import React from 'react';

const options = [
  "Off-price Retailers",
  "Landfill", 
  "Liquidation",
  "Burning"
];

export function DisposalOptions() {
  return (
    <div 
      className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-16 tw-py-14 tw-mt-32 tw-w-full tw-text-5xl tw-leading-snug tw-text-white tw-bg-neutral-700"
      role="region"
      aria-label="Current disposal options"
      style={{background: '#364740'}}
    >
      <div className="tw-flex tw-flex-wrap tw-gap-28 tw-items-center tw-justify-center">
        {options.map((option, index) => (
          <div 
            key={index}
            className="tw-text-normal tw-leading-10 tw-line-through tw-my-auto tw-font-inter tw-text-center"
          >
            {option}
          </div>
        ))}
      </div>
    </div>
  );
}
